export const FormFields = {
    COMMENT_TEXT: 'comment-text',
};

export const COMMENT_TEXT_MAX_LENGTH = 200;
